import GooglePayProcess from 'app/components/OrderPayment/GooglePay/GooglePayProcess';
import React from 'react';

const GooglePayPaymentMob = () => {
  return <GooglePayProcess />;
};

export default GooglePayPaymentMob;
